import { Link } from 'react-router-dom'
export function Footer() {
    return (
        <footer>
            <p>República do Boxe &copy; 2023</p>
            <Link to={"/privacidade"}><p>Política de Privacidade</p></Link>
        </footer>
    );
}